// meldOpensProviderDirectly reports whether the express flow should open the provider straight
// after creating the session instead of showing Confirm & Pay (CS-3534). The server decides
// skipConfirm (buy-checkout handoff, one allowed provider, all-in total shown); the page still keeps
// Confirm unless express is running on that all-in pay-in, so the provider opens on exactly the
// total the checkout showed.
export function meldOpensProviderDirectly({ skipConfirm, express, payIn }) {
  return Boolean(skipConfirm && express && payIn > 0)
}
